// extracted by mini-css-extract-plugin
export default {"healthbar":"Healthbar_healthbar__QdYaX","progressAnimation":"Healthbar_progressAnimation__z++WO","star":"Healthbar_star__tyOlQ","starShadow":"Healthbar_starShadow__XouPQ"};